
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`This tool allows you to correct the ingredients list. You can add, remove or edit
                ingredients list.
                <br>
                This character <span class="highlight">␣</span> represents a space.
                <br>
                This character <span class="highlight">↩︎</span> represents a line break. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `Loading properties...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Help us for ingredients`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Validate crop`,
's03e9c8114521b998': `I'll edit the ingredients`,
's05ec315d9308091a': `Barcode corners icon`,
's061eb5af92512c85': `Saved! Can you help with another one?`,
's06847c221c4c0bc1': `I would like to create a property to [describe your use case]...`,
's06f6c6f99db6b552': `Original`,
's081e2ad82db71e1d': `Grouped Values`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `dedicated documentation`,
's0bb2d48532acc455': `Download CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Invalidate image`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Cancel crop`,
's11a18a69b30b65ed': `Help us fix errors in ingredients list`,
's1205d5f6fccf8e69': `Property Value`,
's15d64a0a6715285a': `New key`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Selection area`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Help us correct the nutritional information`,
's1e00019dc454872d': `Please provide a property name using the property-name attribute.`,
's1e49126af0935a5b': `List of products using this property`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Document the property`,
's300b3a6ee4e1252d': str`Poor Match ${0}%`,
's33f786bb6b4f0cf4': `Crop Result`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Ask the community first`,
's36d86adc823cbfa6': `Before creating a new property, discuss it with the community:`,
's3781d25aa51a736c': `Folksonomy Engine Documentation`,
's383ae4449428b61e': `Reset crop`,
's39bcf88721a1e8ee': `Reset selection`,
's39e14e14300694c7': `Documentation and Guidelines`,
's3b430cfa5c1fe7f4': str`Documentation for ${0}`,
's3f4e4b52f230a892': `Image canvas`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Center image`,
's42dd66b2441566fd': `Center icon`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Resize right`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Product Count`,
's4df2f533c0c1e7d0': `Image controls`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Move selection`,
's4f751fb9b3ed766c': `Creating a New Property`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Enter property name...`,
's55d7249883a98ca1': `about this property on Open Food Facts wiki`,
's565867d84c04aea2': `Filter properties...`,
's5666afe5cd0166de': `Please fix the errors or modify the text before confirming`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Loading products...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Help us correct the nutritional information.`,
's5dd6f12783fca34f': `Edit ingredients list`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Cropped Image`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Good Match ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Documentation`,
's787dd11bed0dc88a': `Resize left`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Learn more about property creation and guidelines:`,
's8038273de2cf8b73': `Please select a region to crop.`,
's839cc2908a5387f2': `Filter barcodes...`,
's86197dcf3e96af64': `Browse and search existing properties`,
's8a63be30a129a59c': `Resize bottom`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Resize top right`,
's8db84aa4bc949af2': `Document the New Property`,
's8f839a03997a16d7': `View Product`,
's901ae1e236ac45d3': `Cancel deletion`,
's907f7a97c6b29425': `Be aware the data model might be modified. Use at your own risk.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Ingredients :`,
's9a7f60fce090ecaf': `Failed to load properties. Please try again later.`,
's9b87abd68fb9df45': `Not found? Create new key {value}`,
's9c0f52425fd2f07e': `May Not Match`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `No Score Available`,
'sa548778b24054030': `Explore all contributed properties from the Folksonomy Engine project. These properties provide additional metadata and insights about products in the Open Food Facts database.`,
'sa63907958bd0ec4b': `Resize top left`,
'sa95b4224f685a36a': `Close modal`,
'sab56a1d439576fd6': `Suggestion icon`,
'sac47ea2901d04c15': `Resize bottom left`,
'sb125227d436c2925': `Search for your property concept in the existing properties database:`,
'sb125568d43642e6f': `Answer questions about the product.`,
'sb1c538e038f9b214': str`Very Good Match ${0}%`,
'sb28639570ff3b852': `list of all properties`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Once you've verified that your property doesn't exist and the community agrees it's useful, you need to first document it in the wiki.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `No products found for this property.`,
'sb7f72e4c8a2d3357': `Filter values...`,
'sb8178320160f84ea': `Show crop`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `All insights have been answered! Thanks for your help!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Corresponding Value`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Resize top`,
'sc1c08d0cbcc3bd24': `Does Not Match`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Suggested fix`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Move image`,
'sc895972c88d38ca5': `Folksonomy property`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Rows`,
'scb3b0671d7b7f640': `New value`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Join Slack Discussion`,
'scdb6cad0b92721bf': `No properties found.`,
'scf23a05631f93732': `Confirm Delete`,
'scfed2f270ef6a3aa': `Select area`,
'sd1022bc1ef9204f7': `Zoomable image`,
'sd1077c055cf9ba6b': `Help us validate the ingredient list of the product.`,
'sd698d21ddecba56b': `Hey! You can help us improve the product information by answering the following parts:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Check if a property already exists`,
'sdbf806fefc584115': `You should find a`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Help us correct the spelling of ingredients.`,
'sdca5deead576ceee': `Resize bottom right`,
'sdcc2555c5dde524f': `Are you sure you want to delete this item? This action cannot be undone.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Invalidate`,
'se5127cf0f92e7e48': `Tip: you can also find the`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `I'll propose a better crop`,
'seea3800e27baa686': `Individual Products`,
'sefaba4adc4ec9219': `Folksonomy Properties`,
'seffa8ca49175b5f0': `Personalized properties`,
'sf44a6b3b232c28ea': str`Replace current value by ${0}`,
'sf4cd86a2f5ef2588': `Product Barcode`,
'sf57a61152168cc81': `Help us correct the ingredient detection`,
'sf88b90b8ba23871c': `Unknown Match`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `Property name:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Corresponding value`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  